module.exports = __webpack_public_path__ + "img/ico-amigo.34c35654.svg";